"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERIES = exports.BREAKPOINTS = void 0;
var BREAKPOINTS = ["".concat(770 / 16, "rem"), "".concat(960 / 16, "rem"), "".concat(1600 / 16, "rem")];
exports.BREAKPOINTS = BREAKPOINTS;
BREAKPOINTS.tabletMin = BREAKPOINTS[0];
BREAKPOINTS.desktopMin = BREAKPOINTS[1];
BREAKPOINTS.desktopMax = BREAKPOINTS[2];
var QUERIES = {
  'tabletAndUp': "(min-width: ".concat(BREAKPOINTS.tabletMin, ")"),
  'desktopDown': "(max-width: ".concat(BREAKPOINTS.desktopMin, ")"),
  'desktopAndUp': "(min-width: ".concat(BREAKPOINTS.desktopMin, ")"),
  'maxDesktop': "(max-width: ".concat(BREAKPOINTS.desktopMax, ")"),
  'navbarBreakpoint': '(min-width: 1129px)',
  'navbarBreakpointDown': '(max-width: 1128px)'
};
exports.QUERIES = QUERIES;